import type { WorkspaceIdentifier } from '../types'
import type { Response } from '../../../types/api/v1'
import type { PaymentIntent } from '../../../types/auth'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const responseDataTypeName: PaymentIntent['type'] = 'payment_intent'

export interface IntentAmount {
  amount: number
}

export type PaymentIntentCreatePayload = IntentAmount & Partial<({
  chargebeeReferenceId: string
  stripePaymentMethodId?: never
} | {
  stripePaymentMethodId: string
  chargebeeReferenceId?: never
})>

export const useFetchPaymentIntent = () => {
  const url = '/me/paymentIntents'

  const { post } = useFetchWithDefaults()

  const create = ({
    workspaceId,
    payload,
  }: WorkspaceIdentifier & { payload: PaymentIntentCreatePayload & { captureMethod?: Maybe<string> } }) =>
    post<Response<PaymentIntent>>({ workspaceId, url, fetchOptions: { body: payload } })

  const confirm = ({ workspaceId, intentId }: WorkspaceIdentifier & { intentId: string }) =>
    post<Response<PaymentIntent>>({
      workspaceId,
      url: `${url}/${intentId}/confirm`,
    })

  return {
    create,
    confirm,
  }
}
